import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconClearSearchFilterGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        d="M10.009 11.1565L10.0002 11.1477L9.99132 11.1565L5.90799 15.2399C5.75779 15.3901 5.56663 15.4654 5.3335 15.4654C5.10036 15.4654 4.90921 15.3901 4.759 15.2399C4.6088 15.0897 4.5335 14.8985 4.5335 14.6654C4.5335 14.4322 4.6088 14.2411 4.759 14.0909L8.84233 10.0075L8.85117 9.9987L8.84233 9.98986L4.759 5.90653C4.6088 5.75632 4.5335 5.56517 4.5335 5.33203C4.5335 5.0989 4.6088 4.90774 4.759 4.75754C4.90921 4.60733 5.10036 4.53203 5.3335 4.53203C5.56663 4.53203 5.75779 4.60733 5.90799 4.75754L9.99132 8.84087L10.0002 8.84971L10.009 8.84087L14.0923 4.75754C14.2425 4.60733 14.4337 4.53203 14.6668 4.53203C14.9 4.53203 15.0911 4.60733 15.2413 4.75754C15.3915 4.90774 15.4668 5.0989 15.4668 5.33203C15.4668 5.56517 15.3915 5.75632 15.2413 5.90653L11.158 9.98986L11.1492 9.9987L11.158 10.0075L15.2413 14.0909C15.3915 14.2411 15.4668 14.4322 15.4668 14.6654C15.4668 14.8985 15.3915 15.0897 15.2413 15.2399C15.0911 15.3901 14.9 15.4654 14.6668 15.4654C14.4337 15.4654 14.2425 15.3901 14.0923 15.2399L10.009 11.1565Z"
        fill={fillColor}
        stroke={fillColor}
        strokeWidth="0.025"
      />
    </g>
  );
};

export const IconClearSearchFilterSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...(props.svg ?? {})}
    >
      <IconClearSearchFilterGroup {...props} />
    </svg>
  );
};
